import React from 'react';

export function Copyright() {
  return (
    <div className="body-small-white-90 text-center md:text-left no-margin">
      <a 
        href="https://epko.tech" 
        className="hover:text-white transition-colors body-small-white-90 no-margin"
        rel="dofollow"
        title="Odwiedź stronę EPKO sp. z o.o. - twórcy tej strony"
      >
        © 2025 EPKO sp. z o.o. Wszelkie prawa zastrzeżone.
      </a>
    </div>
  );
}